import FiltersDisplayCondition from './FiltersDisplayCondition';
import FiltersDisplayRelatedConditionsHeading from './FiltersDisplayRelatedConditionsHeading';
import { isLogicGroup, LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { isAssociationBranch } from '../../strategy/InboundDbListSegStrategyUtils';
import styled from 'foundations-theming/utils';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FILTERS_Y_SPACING = 2;
const BULLET_POINT_X_POSITION = -10;
const DisplayConditionsList = styled.div.withConfig({
  displayName: "FiltersDisplayRelatedConditions__DisplayConditionsList",
  componentId: "sc-1643mn9-0"
})(({
  isAssociation,
  theme
}) => ({
  '> *': Object.assign({
    position: 'relative',
    marginTop: `${FILTERS_Y_SPACING}px`,
    paddingLeft: theme.space[500]
  }, isAssociation ? {} : {
    marginLeft: `${-BULLET_POINT_X_POSITION + 10}px`,
    '&::before': {
      content: '',
      position: 'absolute',
      top: theme.space[200],
      left: `${BULLET_POINT_X_POSITION + 10}px`,
      width: '5px',
      height: '5px',
      borderRadius: '50%',
      backgroundColor: theme.color['text-core-default'],
      borderTop: '5px solid white',
      borderBottom: '5px solid white',
      boxSizing: 'content-box',
      zIndex: 2
    },
    '&:first-child': {
      '&::after': {
        top: `${FILTERS_Y_SPACING + 9}px`
      },
      '&:last-child': {
        '&::after': {
          bottom: 'auto',
          height: `${FILTERS_Y_SPACING + 9}px`
        }
      },
      '&:first-child:last-child': {
        '&::after': {
          display: 'none'
        }
      }
    }
  })
}));
const FiltersDisplayRelatedConditions = props => {
  const {
    logicGroup,
    conditionPath
  } = props;
  const logicGroupConditionsSeq = logicGroup.conditions.entrySeq();
  const isAssociation = isAssociationBranch(logicGroup);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FiltersDisplayRelatedConditionsHeading, {
      conditionPath: conditionPath,
      logicGroup: logicGroup
    }), /*#__PURE__*/_jsx(DisplayConditionsList, {
      isAssociation: isAssociation,
      children: logicGroupConditionsSeq.map(([key, condition], index) => {
        const currConditionPath = conditionPath.push(key);
        if (isLogicGroup(condition)) {
          return (
            /*#__PURE__*/
            /* eslint-disable-next-line react/jsx-key */
            _jsx(FiltersDisplayRelatedConditions, {
              conditionPath: currConditionPath,
              logicGroup: condition,
              parentLogicGroupOperator: LogicGroupNames.AND
            })
          );
        }
        return /*#__PURE__*/_jsx(FiltersDisplayCondition, {
          condition: condition,
          filterFamily: logicGroup.filterFamily,
          parentLogicGroup: logicGroup,
          isFirst: true
        }, `${index}-${key}`);
      })
    }), logicGroup.errors.map((error, index) => /*#__PURE__*/_jsx(Text, {
      display: "block",
      marginBlockStart: "200",
      typography: "heading-25",
      use: "error",
      children: error.message
    }, `${conditionPath.join('_')}_error_${index}`))]
  });
};
export default FiltersDisplayRelatedConditions;